<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="operateTarget" slot-scope="scope">
        <el-tag :class="'target-type-class-' + scope.row.operateTarget">{{
          getTargetTypeName(scope.row.operateTarget)
        }}</el-tag>
      </template>
      <template slot="syncType" slot-scope="scope">
        <el-tag :class="getClass(scope.row.syncType)">{{
          scope.row.syncType === 1 ? '钉钉' : '微信'
        }}</el-tag>
      </template>
      <template slot="operateType" slot-scope="scope">
        <el-tag :class="'operate-class-' + scope.row.operateType">{{
          getOperateTypeName(scope.row.operateType)
        }}</el-tag>
      </template>
      <template slot="operateStatus" slot-scope="scope">
        <el-tag
          :class="'operate-status-class-' + scope.row.operateStatus + ' operate-status-class-width'"
          >{{ getOperateStatusName(scope.row.operateStatus) }}</el-tag
        >
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.syncoperatelog_delete"
          @click="handleDelete"
          >删 除
        </el-button>
        <el-button
          type="warning"
          size="small"
          icon="el-icon-files"
          @click="initSync"
          v-if="permission.syncoperatelog_initsync"
          >初始化同步
        </el-button>
        <el-button
          type="paimary"
          size="small"
          icon="el-icon-files"
          @click="syncOperate"
          v-if="permission.syncoperatelog_sync"
          >同步操作
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-grape"
          @click="handleSync"
          v-if="permission.syncoperatelog_resync"
          >批量重发
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-sort"
          plain="true"
          v-if="showResendBtn(scope.row)"
          @click="reSync(scope.row.id)"
        >
          重新同步
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getList,
  getDetail,
  add,
  update,
  remove,
  reSync,
  initialSync,
  syncOperate,
} from '@/api/v4ward/dingtalk/syncoperatelog';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        selection: true,
        addBtn: false,
        searchMenuSpan: 6,
        align: 'center',
        column: [
          {
            label: '操作目标',
            prop: 'operateTarget',
            slot: true,
            search: true,
            searchSpan: 4,
            type: 'select',
            dicData: [
              { label: '员工', value: 'USER' },
              { label: '部门', value: 'DEPT' },
            ],
          },
          {
            label: '目标名称',
            prop: 'targetName',
          },
          {
            label: '操作类型',
            prop: 'operateType',
            slot: true,
            search: true,
            searchSpan: 4,
            type: 'select',
            dicData: [
              { label: '新增操作', value: 'ADD' },
              { label: '修改操作', value: 'UPDATE' },
              { label: '删除操作', value: 'DELETE' },
            ],
          },
          {
            label: '远程服务',
            prop: 'syncType',
            slot: true,
            search: true,
            searchSpan: 4,
            type: 'select',
            dicData: [
              { label: '钉钉', value: 1 },
              { label: '微信', value: 2 },
            ],
          },
          {
            label: '同步状态',
            prop: 'operateStatus',
            search: true,
            searchSpan: 4,
            slot: true,
            type: 'select',
            dicData: [
              { label: '待同步', value: 0 },
              { label: '同步成功', value: 1 },
              { label: '待员工同意', value: 2 },
              { label: '同步异常', value: 3 },
              { label: '操作被覆盖', value: 4 },
            ],
          },
          {
            label: '同步说明',
            prop: 'errorRemark',
            overHidden: true,
          },
          {
            label: '操作人',
            prop: 'createUserName',
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            type: 'date',
            format: 'MM-dd HH:mm:ss',
            width: 130,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    syncOperate() {
      this.$confirm('确定将所有【待同步】的操作同步到远端？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          return syncOperate();
        })
        .then((res) => {
          this.refreshChange();
          this.$message.success(res.data);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    initSync() {
      this.$confirm('此操作将删除钉钉远端用户部门数据，然后将本地数据同步到远端，请谨慎操作！', {
        confirmButtonText: '确定初始化',
        cancelButtonText: '取消操作',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          return initialSync();
        })
        .then(() => {
          this.loading = false;
          this.$message.success('初始化成功!');
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //批量同步
    handleSync() {
      let ids = [];
      let cancelRows = [];
      if (this.selectionList.length > 0) {
        this.selectionList.forEach((e) => {
          if (e.operateStatus === 1 || e.operateStatus === 4) {
            this.$message.warning('过滤掉不可重发的操作!');
            cancelRows.push(e);
          } else {
            ids.push(e.id);
          }
        });
      }
      if (cancelRows.length > 0) {
        this.$refs.crud.toggleSelection(cancelRows);
        this.$alert('已过滤掉部分不可重发数据，请返回确认后重新提交！');
        return;
      }
      if (this.selectionList.length === 0 || ids.length === 0) {
        this.$message.warning('请至少选择一条可同步数据!');
        return;
      }
      this.$confirm('确定将选择数据再次同步?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          return reSync(ids.join(','));
        })
        .then(() => {
          this.loading = false;
          this.$alert('操作成功,请稍后刷新查看状态!', '发送完成', {
            confirmButtonText: '确定',
            callback: (action) => {},
          });
          this.$refs.crud.toggleSelection();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //单条同步
    reSync(id) {
      console.log('重新发送。。。' + id);
      this.$confirm('确定重新发送同步操作?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          return reSync(id);
        })
        .then(() => {
          this.loading = false;
          this.$alert('操作成功,请稍后刷新查看状态!', '发送完成', {
            confirmButtonText: '确定',
            callback: (action) => {},
          });
          this.$refs.crud.toggleSelection();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    showResendBtn(row) {
      return (
        (row.operateStatus === 0 || row.operateStatus === 2 || row.operateStatus === 3) &&
        this.vaildData(this.permission.syncoperatelog_resync, false)
      );
    },
    getOperateTypeName(operateType) {
      var operateTypeName = operateType;
      if (operateType === 'ADD') {
        operateTypeName = '新增操作';
      } else if (operateType === 'UPDATE') {
        operateTypeName = '修改操作';
      } else if (operateType === 'DELETE') {
        operateTypeName = '删除操作';
      }
      return operateTypeName;
    },
    getTargetTypeName(targetType) {
      var targetTypeName = targetType;
      if (targetType === 'USER') {
        targetTypeName = '用户';
      } else if (targetType === 'DEPT') {
        targetTypeName = '部门';
      }
      return targetTypeName;
    },
    getOperateStatusName(status) {
      var dicData = [
        { label: '待同步', value: 0 },
        { label: '同步成功', value: 1 },
        { label: '待员工同意', value: 2 },
        { label: '同步异常', value: 3 },
        { label: '操作被覆盖', value: 4 },
      ];
      var label = status;
      dicData.forEach((e) => {
        if (e.value === status) {
          label = e.label;
        }
      });
      return label;
    },
    getClass(syncType) {
      if (syncType === 2) {
        return 'tag-wx';
      } else {
        return '';
      }
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },

    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style>
.tag-wx {
  background-color: #daffde;
  color: green;
}

.operate-class-ADD {
  background-color: #f0ffff;
  color: #0000ff;
  width: 70px;
}
.operate-class-UPDATE {
  background-color: #fffff0;
  color: #00ff00;
  width: 70px;
}
.operate-class-DELETE {
  background-color: #fff0ff;
  color: #ff0000;
  width: 70px;
}
.operate-status-class-0 {
  background-color: #f0ffff;
  color: #0000ff;
}
.operate-status-class-1 {
  background-color: #daffde;
  color: green;
}
.operate-status-class-2 {
  background-color: #fffff0;
  color: #00ff00;
}
.operate-status-class-3 {
  background-color: #fff0ff;
  color: #ff0000;
}
.operate-status-class-4 {
  background-color: #ffffff;
  color: #b5b5b5;
}
.operate-status-class-width {
  width: 80px;
}
.target-type-class-DEPT {
  background-color: #efffe3;
  color: #005400;
}
</style>
